const WORDS_TO_EXCLUDE = ['and', 'the', 'of', 'london', '&'];
export const getNameForAvatar = (name: string) => {
    const tokens = name
        .trim()
        .split(' ')
        .filter((token) => WORDS_TO_EXCLUDE.indexOf(token.toLowerCase()) < 0);

    return [tokens.shift() || '', tokens.pop() || ''];
};
